import { render } from "./TheRehabilitation.vue?vue&type=template&id=46f7f15e&scoped=true"
import script from "./TheRehabilitation.vue?vue&type=script&lang=js"
export * from "./TheRehabilitation.vue?vue&type=script&lang=js"

import "./TheRehabilitation.vue?vue&type=style&index=0&id=46f7f15e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f7f15e"]])

export default __exports__